// Única salida del navegador hacia el servidor del portal: mismo origen, cookie HttpOnly y, en cada escritura, el token
// antiforgery que entrega el servidor. Nunca habla con un microservicio ni guarda tokens en el navegador.
let antiforgeryToken: string | null = null;

/** Guarda el token antiforgery que devolvió el servidor (va en la cabecera de cada escritura). */
export function setAntiforgeryToken(token: string | null): void {
  antiforgeryToken = token;
}

/** Token antiforgery vigente (en memoria; nunca en el almacenamiento del navegador). */
export function getAntiforgeryToken(): string | null {
  return antiforgeryToken;
}

/** Error HTTP del portal con su código y, si el servidor lo mandó, el código del Error Hub. */
export class PortalHttpError extends Error {
  constructor(
    readonly status: number,
    readonly code: string | null,
    readonly body: unknown,
  ) {
    super(`HTTP ${status}${code ? ` (${code})` : ""}`);
  }
}

/** Mutator de Orval: misma firma que fetch, devuelve el cuerpo ya leído. */
export async function portalFetch<T>(url: string, init: RequestInit = {}): Promise<T> {
  const method = (init.method ?? "GET").toUpperCase();
  const headers = new Headers(init.headers);
  headers.set("Accept", "application/json");
  if (method !== "GET" && method !== "HEAD" && antiforgeryToken) headers.set("X-CSRF-TOKEN", antiforgeryToken);
  const response = await fetch(url, { ...init, headers, credentials: "same-origin" });
  const text = await response.text();
  const body: unknown = text ? JSON.parse(text) : undefined;
  if (!response.ok) {
    const code =
      typeof body === "object" && body !== null && "code" in body ? String((body as { code: unknown }).code) : null;
    throw new PortalHttpError(response.status, code, body);
  }
  return body as T;
}
